<script setup lang="ts">
import { computed } from 'vue'

interface TemperatureFieldsData {
  temperature_setpoint: number
  temperature_value_divisor: number
}

interface Props {
  modelValue: TemperatureFieldsData
}

interface Emits {
  (e: 'update:modelValue', value: TemperatureFieldsData): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const formData = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})
</script>

<template>
  <div class="space-y-4">
    <div class="grid grid-cols-2 gap-4">
      <div>
        <label for="temperature_setpoint" class="block text-sm font-medium"> Temperatura crítica (°C) </label>
        <input
          v-model.number="formData.temperature_setpoint"
          type="number"
          step=".1"
          id="temperature_setpoint"
          class="mt-1 block w-full border border-bodydark2 px-3 py-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" />
      </div>
      <div>
        <label for="temperature_value_divisor" class="block text-sm font-medium"> Divisor do valor de temperatura </label>
        <input
          v-model.number="formData.temperature_value_divisor"
          type="number"
          step="0.01"
          min="0.01"
          id="temperature_value_divisor"
          placeholder="10"
          class="mt-1 block w-full border border-bodydark2 px-3 py-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" />
        <p class="mt-0.5 text-xs text-gray-500">Usado para converter leitura bruta em °C</p>
      </div>
    </div>
  </div>
</template>
